'use strict';

//type:attr attrVal:数组对象中已有属性名    

export default function (arrary, attrName, type ,attrVal) {
    if (arrary instanceof Array) {
        if (type == 'attr') {
            return _.map(arrary, function (o) {
                let obj = {};
                obj[attrName]=_.get(o, attrVal).split("@")[0];
                return _.assign(o, obj);
            })
        }
    } else {
        return arrary;
    }

}


// WEBPACK FOOTER //
// ./src/common/filters/attr-add.js